const RootPath = window.g.baseUrl
const apis = {
  // 获取汇总数据
  getSummaryList: RootPath + 'plugin/product/default/GetSummaryList',
  exportSummaryList: RootPath + 'plugin/product/default/ExportSummaryList',
  getDetailData: RootPath + 'plugin/product/default/GetDetailData',
  //删除样本册
  delDefaultSample: RootPath + 'plugin/product/default/DelSample'
}

export default apis
